// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq3 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Promotions_Types_Id.eqPromotionId);
var eq4 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Money_Rounded.eqMoney));
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var selectionIsSymbol = {
    reflectSymbol: function () {
        return "selection";
    }
};
var FreeProductInputIsSymbol = {
    reflectSymbol: function () {
        return "FreeProductInput";
    }
};
var NoInputIsSymbol = {
    reflectSymbol: function () {
        return "NoInput";
    }
};
var productGroupIndexIsSymbol = {
    reflectSymbol: function () {
        return "productGroupIndex";
    }
};
var productSequenceNumIsSymbol = {
    reflectSymbol: function () {
        return "productSequenceNum";
    }
};
var ProductReferenceIsSymbol = {
    reflectSymbol: function () {
        return "ProductReference";
    }
};
var activeIsSymbol = {
    reflectSymbol: function () {
        return "active";
    }
};
var assignmentIsSymbol = {
    reflectSymbol: function () {
        return "assignment";
    }
};
var inputIsSymbol = {
    reflectSymbol: function () {
        return "input";
    }
};
var promotionIdIsSymbol = {
    reflectSymbol: function () {
        return "promotionId";
    }
};
var promotionalItemIdIsSymbol = {
    reflectSymbol: function () {
        return "promotionalItemId";
    }
};
var sourceIsSymbol = {
    reflectSymbol: function () {
        return "source";
    }
};
var valueIsSymbol = {
    reflectSymbol: function () {
        return "value";
    }
};
var PromotionalItemIsSymbol = {
    reflectSymbol: function () {
        return "PromotionalItem";
    }
};
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode);
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons1 = /* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil);
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode);
var FreeProductInput = /* #__PURE__ */ (function () {
    function FreeProductInput(value0) {
        this.value0 = value0;
    };
    FreeProductInput.create = function (value0) {
        return new FreeProductInput(value0);
    };
    return FreeProductInput;
})();
var NoInput = /* #__PURE__ */ (function () {
    function NoInput() {

    };
    NoInput.value = new NoInput();
    return NoInput;
})();
var ProductReference = function (x) {
    return x;
};
var PromotionalItem = function (x) {
    return x;
};
var toFillFormTypePromotional = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypePromotional1 = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeProductRefe = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypePromotionalItem_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeProductReference_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldPromotionalItem = function (dictHasField) {
    return dictHasField;
};
var hasFieldProductReference = function (dictHasField) {
    return dictHasField;
};
var eqPromotionalItemInput = {
    eq: function (x) {
        return function (y) {
            if (x instanceof FreeProductInput && y instanceof FreeProductInput) {
                return x.value0.selection === y.value0.selection;
            };
            if (x instanceof NoInput && y instanceof NoInput) {
                return true;
            };
            return false;
        };
    }
};
var eq5 = /* #__PURE__ */ Data_Eq.eq(eqPromotionalItemInput);
var eqProductReference = {
    eq: function (x) {
        return function (y) {
            return x.productGroupIndex === y.productGroupIndex && x.productSequenceNum === y.productSequenceNum;
        };
    }
};
var eq6 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(eqProductReference));
var eq7 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(eqProductReference));
var eqPromotionalItem = {
    eq: function (x) {
        return function (y) {
            return x.active === y.active && eq6(x.assignment)(y.assignment) && eq5(x.input)(y.input) && eq3(x.promotionId)(y.promotionId) && x.promotionalItemId === y.promotionalItemId && eq7(x.source)(y.source) && eq4(x.value)(y.value);
        };
    }
};
var genericPromotionalItemInput = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new FreeProductInput(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return NoInput.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Promotions.Types.PromotionalItem (line 19, column 1 - line 19, column 95): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof FreeProductInput) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof NoInput) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Promotions.Types.PromotionalItem (line 19, column 1 - line 19, column 95): " + [ x.constructor.name ]);
    }
};
var showPromotionalItemInput = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionalItemInput)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(selectionIsSymbol)(Data_Show.showString))))(FreeProductInputIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(NoInputIsSymbol)))
};
var unscrambleDecodePromotionalItemInput = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionalItemInput)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(FreeProductInputIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons(selectionIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)(NoInputIsSymbol))))(Unscramble_Generic.defaultOptions)
};
var genericPromotionalItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericProductReference = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showProductReference = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductReference)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(productGroupIndexIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(productSequenceNumIsSymbol)(Data_Show.showInt))(Data_Show.showInt))))(ProductReferenceIsSymbol))
};
var showPromotionalItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionalItem)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(activeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(assignmentIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(inputIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(promotionIdIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(promotionalItemIdIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(sourceIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(valueIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Money_Rounded.showMoney)))(/* #__PURE__ */ Data_Show.showArray(showProductReference)))(Data_Show.showInt))(Restaumatic_Promotions_Types_Id.showPromotionId))(showPromotionalItemInput))(/* #__PURE__ */ Data_Maybe.showMaybe(showProductReference)))(Data_Show.showBoolean))))(PromotionalItemIsSymbol))
};
var unscrambleDecodeProductReference = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericProductReference)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(productGroupIndexIsSymbol)(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons(productSequenceNumIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodePromotionalItem = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionalItem)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(activeIsSymbol)(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons(assignmentIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(unscrambleDecodeProductReference))(/* #__PURE__ */ Unscramble.decodeRecordCons(inputIsSymbol)(unscrambleDecodePromotionalItemInput)(/* #__PURE__ */ Unscramble.decodeRecordCons(promotionIdIsSymbol)(Restaumatic_Promotions_Types_Id.decodePromotionId)(/* #__PURE__ */ Unscramble.decodeRecordCons(promotionalItemIdIsSymbol)(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons(sourceIsSymbol)(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeProductReference))(/* #__PURE__ */ Unscramble.decodeRecordCons(valueIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Data_Money_Rounded.udecodeMoney))(Unscramble.decodeRecordNil)))))))))))(Unscramble_Generic.defaultOptions)
};
var encodePromotionalItemInput = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionalItemInput)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(FreeProductInputIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons1(selectionIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(NoInputIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments)))
};
var encodeProductReference = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericProductReference)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ProductReferenceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(productSequenceNumIsSymbol)(encodeWithOptionsOther))(productGroupIndexIsSymbol)(encodeWithOptionsOther)))))
};
var encodePromotionalItem = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionalItem)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PromotionalItemIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(valueIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Data_Money_Rounded.encodeMoney))))(sourceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeProductReference))))(promotionalItemIdIsSymbol)(encodeWithOptionsOther))(promotionIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Promotions_Types_Id.encodePromotionId)))(inputIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodePromotionalItemInput)))(assignmentIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(encodeProductReference))))(activeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))
};
var decodePromotionalItemInput = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionalItemInput)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(FreeProductInputIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons1(selectionIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(NoInputIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))
};
var decodeProductReference = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericProductReference)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ProductReferenceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(productSequenceNumIsSymbol)(decodeWithOptionsOther)())(productGroupIndexIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodePromotionalItem = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionalItem)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PromotionalItemIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(valueIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Data_Money_Rounded.decodeMoney)))())(sourceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeProductReference)))())(promotionalItemIdIsSymbol)(decodeWithOptionsOther)())(promotionIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Promotions_Types_Id.decodePromotionId1))())(inputIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodePromotionalItemInput))())(assignmentIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(decodeProductReference)))())(activeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    FreeProductInput,
    NoInput,
    PromotionalItem,
    ProductReference,
    genericPromotionalItemInput,
    eqPromotionalItemInput,
    showPromotionalItemInput,
    encodePromotionalItemInput,
    decodePromotionalItemInput,
    unscrambleDecodePromotionalItemInput,
    toFillFormTypePromotional1,
    genericPromotionalItem,
    eqPromotionalItem,
    showPromotionalItem,
    encodePromotionalItem,
    decodePromotionalItem,
    unscrambleDecodePromotionalItem,
    toFillFormTypePromotional,
    hasFieldPromotionalItem,
    newtypePromotionalItem_,
    genericProductReference,
    eqProductReference,
    showProductReference,
    encodeProductReference,
    decodeProductReference,
    unscrambleDecodeProductReference,
    toFillFormTypeProductRefe,
    hasFieldProductReference,
    newtypeProductReference_
};
